export default __webpack_public_path__ + "static/Leto-33a0591966535ff315e20440060165aa.png";